import { Component } from '@angular/core';
import { InspectionListComponent } from './list.component';

@Component({
    selector: 'installation-list-table',
    templateUrl: './installation-list.component.html',
    standalone: false
})
export class InstallationListComponent extends InspectionListComponent {}
